module.exports = __webpack_public_path__ + "img/moqing.3b6155f7.png";